<template>
  <div>
   <Header></Header>
    <div class="container">
      <div class="mainer box1">
        <div class="details">
          <div class="clearfix">
            <div class="details_left clearfix">
              <div class="list_img">
                <img
                  :src="dataset.logo"
                />
              </div>
              <div class="list_text">
                <div class="title clearfix">
                  <div class="c_name">{{this.dataset.title}}</div>
                </div>
                <ul class="details_list clearfix">
                  <li class="list_item borderNone">
                    <br />
                    <span class="item_text">{{this.dataset.participation}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mainer box1">
        <div class="introduce_title title_margin1">高校简介</div>
        <div class="gx_content">
          {{this.dataset.content}}
        </div>
        <div class="introduce_title title_margin1">联系地址</div>
        <div class="gx_content">
          {{this.dataset.province+this.dataset.city+this.dataset.region+this.dataset.address}}
        </div>
        <div class="introduce_title title_margin1">联系方式</div>
        <div class="gx_content">
          <p>联系人：{{this.dataset.linkname}}</p>
          <p>联系电话：{{this.dataset.z_mobile}}</p>
        </div>
        <div class="introduce_title title_margin1">2023届毕业生生源信息</div>
        <div class="gx_content">
          <a :href="this.dataset.bys_file" target="_blank" style="color:blue">点击下载</a>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
// import Vue from "vue";
// import "@/icons/iconfont.js";
import Header from "../component/mheader.vue";
import { selfRequest_gsd } from "@/api/discoverydata";
export default {
  name: "detail",
  components: {Header},
  data() {
    return {
      query_id: "",
      dataset: {},
    };
  },
  created() {
    this.query_id = this.$route.params.id;
    selfRequest_gsd({ school_id: this.query_id }).then((res) => {
      // console.log(res);
      var tempArr = []
      tempArr = res.data
      tempArr.linkname = tempArr.linkname.substring(0,1)+'老师'
      this.dataset = tempArr;
      document.title = this.dataset.title;
    });
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.container {
  width: 100%;
}
.mainer {
  overflow: hidden;
  margin-top: 15px;
  margin-bottom: 30px;
}
.box1 {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  background: #ffffff;
  padding: 10px 20px 20px;
  margin-bottom: 15px;
  /* height: 500px; */
}
.details {
    padding: 35px 30px 24px;
}
.clearfix:after, .clearfix:before {
    content: "";
    display: table;
}
.details_left {
    float: left;
}
.clearfix:after, .clearfix:before {
    content: "";
    display: table;
}
.list_img {
    width: 90px;
    height: 90px;
    float: left;
    margin-right: 20px;
    margin-top: 0;
}
.list_img img {
    width: 90px;
    height: 90px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.list_text {
    float: left;
}
.list_text .title {
    font-size: 26px;
    color: #333333;
    margin-bottom: 20px;
}
.clearfix:after, .clearfix:before {
    content: "";
    display: table;
}
.list_text .title .c_name {
    float: left;
    height: 30px;
    line-height: 30px;
    font-size: 26px;
    max-width: 720px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.list_text .details_list {
    margin-left: -13px;
}
.clearfix:after, .clearfix:before {
    content: "";
    display: table;
}
.details_list .borderNone {
    border-left: none;
}
.details_list li {
    height: 46px;
    float: left;
    text-align: center;
    border-left: 1px solid #f3f3f3;
    padding: 0 24px;
}
.item_num {
    font-size: 16px;
    color: #ff6600;
}
.item_text {
    font-size: 12px;
    color: #999999;
}
.title_margin1 {
    margin-bottom: 27px;
}
.introduce_title {
    padding: 15px 30px 0px;
    text-align: left;
    color: #333333;
    font-size: 20px;
    font-weight: bold;
}
.gx_content{
  text-align: left;
  padding: 5px 30px 24px;
  font-size: 16px;
  line-height: 30px;
}
@media all and (min-width: 768px) and (max-width: 1170px) {
  .box1 {
    width: 100%;
  }
}
</style>
